import clsx from "clsx";
import { AriaRole, ReactNode } from "react";

import { ErrorDisplay } from "./error";

export const FieldSet = ({
  children,
  direction,
  error,
  errorId,
  role,
  uri,
}: {
  children: ReactNode;
  direction?: "row" | "column";
  error?: string;
  errorId?: string;
  role?: AriaRole;
  uri: string;
}) => (
  <fieldset
    className={clsx(
      "flex border-0 bg-none mx-0 p-0 gap-[1.2rem] w-full relative",
      direction === "row" ? "flex-row" : "flex-col",
    )}
    aria-invalid={!!error}
    aria-errormessage={error && errorId}
    role={role}
  >
    {children}
    <ErrorDisplay uri={uri} error={error} />
  </fieldset>
);
